"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFramePromotionEditViewModel = instanceOfFramePromotionEditViewModel;
exports.FramePromotionEditViewModelFromJSON = FramePromotionEditViewModelFromJSON;
exports.FramePromotionEditViewModelFromJSONTyped = FramePromotionEditViewModelFromJSONTyped;
exports.FramePromotionEditViewModelToJSON = FramePromotionEditViewModelToJSON;
exports.FramePromotionEditViewModelToJSONTyped = FramePromotionEditViewModelToJSONTyped;
const FramePromotionDetailItem_1 = require("./FramePromotionDetailItem");
/**
 * Check if a given object implements the FramePromotionEditViewModel interface.
 */
function instanceOfFramePromotionEditViewModel(value) {
    if (!('fpmName' in value) || value['fpmName'] === undefined)
        return false;
    if (!('fpmPrice' in value) || value['fpmPrice'] === undefined)
        return false;
    return true;
}
function FramePromotionEditViewModelFromJSON(json) {
    return FramePromotionEditViewModelFromJSONTyped(json, false);
}
function FramePromotionEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fpmNo': json['fpmNo'] == null ? undefined : json['fpmNo'],
        'fpmName': json['fpmName'],
        'fpmDesc': json['fpmDesc'] == null ? undefined : json['fpmDesc'],
        'fpmPrice': json['fpmPrice'],
        'fpmStatus': json['fpmStatus'] == null ? undefined : json['fpmStatus'],
        'fpmStartDate': json['fpmStartDate'] == null ? undefined : (new Date(json['fpmStartDate'])),
        'fpmEndDate': json['fpmEndDate'] == null ? undefined : (new Date(json['fpmEndDate'])),
        'details': json['details'] == null ? undefined : (json['details'].map(FramePromotionDetailItem_1.FramePromotionDetailItemFromJSON)),
    };
}
function FramePromotionEditViewModelToJSON(json) {
    return FramePromotionEditViewModelToJSONTyped(json, false);
}
function FramePromotionEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fpmNo': value['fpmNo'],
        'fpmName': value['fpmName'],
        'fpmDesc': value['fpmDesc'],
        'fpmPrice': value['fpmPrice'],
        'fpmStatus': value['fpmStatus'],
        'fpmStartDate': value['fpmStartDate'] == null ? undefined : (value['fpmStartDate'].toISOString()),
        'fpmEndDate': value['fpmEndDate'] == null ? undefined : (value['fpmEndDate'].toISOString()),
        'details': value['details'] == null ? undefined : (value['details'].map(FramePromotionDetailItem_1.FramePromotionDetailItemToJSON)),
    };
}
